export class Dictionary<T> {
  [id: string]: T | undefined;
  [id: number]: T | undefined;
}
